"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgGoToLeadmailer = function SvgGoToLeadmailer(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.76 8 4.681 3.103L20.231 8H10.76Zm10.74.37V17h-12l.002-.781h-1l-.002.778A1 1 0 0 0 9.5 18h12a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1H9.522a1 1 0 0 0-1 .998L8.52 9.09h1l.001-.711 5.64 3.738.274.181.275-.178 5.79-3.75Z",
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#007AFF",
    d: "M1.502 10.127h7v1h-7zm2 2h4v1h-4v-1Zm2 2h3v1h-3z"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgGoToLeadmailer);
var _default = exports["default"] = Memo;